import { text } from '@clack/prompts'
import as from 'ansis'
import { Command } from 'commander'

import { apiService } from '@/helpers'
import { output } from '@/helpers/std-out'

export const CreateCommand = () => {
  const cmd = new Command('create')

  cmd.description(
    'Create a new project that is not linked to a github project.',
  )
  cmd.option('-n, --name [name]', 'name of your project')
  cmd.option('-s, --slug [slug]', 'project slug')
  cmd.action(async ({ name, slug }) => {
    const apiClient = await apiService()

    let nameValue = name
    let slugValue = slug

    if (!nameValue) {
      nameValue = await text({
        message: 'What is the name of your project?',
        validate(value: string) {
          if (value.trim().length === 0) {
            return 'You did not provide a project name. Please provide a name!'
          }

          return
        },
      })
    }

    if (!slugValue) {
      slugValue = await text({
        message: 'What is the slug of your project? (Optional)',
        defaultValue: undefined,
      })
    }

    const logger = output.info().loader('Creating the project')
    const response = await apiClient.github.createProject({
      name: nameValue,
      slug: slugValue,
    })

    if (response.error) {
      return output
        .error()
        .title('Something went wrong')
        .message(response.message)
        .exit('error')
    }

    logger.update('loader', 0, { content: 'Project created successfully!' })
    logger
      .message(
        `Project uid: ${as.cyan(response.data.uid)}\nProject slug: ${as.cyan(response.data.slug)}`,
      )
      .exit('success')
  })

  return cmd
}
